import { AfterViewInit, Directive, ElementRef, Injector, OnDestroy, OnInit } from "@angular/core";
import { FrameContext } from "@farris/devkit";
import { ComboLookupComponent } from '@farris/ui-combo-lookup';
import { ComponentRef } from "./component-ref";

@Directive({
  selector: '[comboLookupRef]'
})
export class ComboLookupComponentRefDirective extends ComponentRef implements OnInit, OnDestroy, AfterViewInit {
  constructor(private injector: Injector, private component: ComboLookupComponent, public elementRef: ElementRef, public frameContext: FrameContext) { 
    super(frameContext, elementRef);
  }
  ngAfterViewInit(): void {
    this.tryAddComponent(this.component);
  }
  ngOnInit(): void {
    this.addComponent(this.component);
  }
  ngOnDestroy(): void {
  }

}